import L from "leaflet";

export const AmbulanceIcon = L.icon({
	iconUrl: require("../../../shared/assets/images/green_pin.png"),
	iconSize: [30, 40],
});
